(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-claude"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll(".announcement-bar__scroller").forEach(function (scroller) {
    var track = scroller.querySelector(".announcement-bar__track");
    var originalSet = track && track.querySelector(".announcement-bar__set");
    if (!track || !originalSet) return;

    var pauseOnHover = scroller.dataset.pauseOnHover === "true";

    function init() {
      var cycleWidth = originalSet.offsetWidth;
      if (!cycleWidth) return;

      var needed = Math.ceil((window.innerWidth * 4) / cycleWidth) + 1;
      var current = track.querySelectorAll(".announcement-bar__set").length;

      for (var i = current; i < needed; i++) {
        var clone = originalSet.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      }

      track.style.setProperty("--ann-translate", "-" + cycleWidth + "px");
      track.classList.add("is-animating");
    }

    if (document.fonts) {
      document.fonts.ready.then(init);
    } else {
      init();
    }

    if (pauseOnHover) {
      scroller.addEventListener("mouseenter", function () { track.classList.add("is-paused"); });
      scroller.addEventListener("mouseleave", function () { track.classList.remove("is-paused"); });
      scroller.addEventListener("focusin", function () { track.classList.add("is-paused"); });
      scroller.addEventListener("focusout", function () { track.classList.remove("is-paused"); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page1"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector(".hn-split");
  if (!section) return;
  var id = section.id.replace("hn-", "");
  var doneKey     = "hn_done_"     + id;
  var redirectKey = "hn_redirect_" + id;
  var fnameKey    = "hn_fname_"    + id;
  var lnameKey    = "hn_lname_"    + id;
  var sizeKey     = "hn_size_"     + id;
  var cemailKey   = "hn_cemail_"   + id;

  var step1      = document.getElementById("hn-step1-"        + id);
  var step2      = document.getElementById("hn-step2-"        + id);
  var successEl  = document.getElementById("hn-success-"      + id);
  var step1Btn   = document.getElementById("hn-step1-btn-"    + id);
  var form2      = document.getElementById("hn-form2-"        + id);
  var emailIn    = document.getElementById("hn-email-"        + id);
  var emailHid   = document.getElementById("hn-email-hidden-" + id);
  var emailErr   = document.getElementById("hn-email-err-"    + id);
  var tagsIn     = document.getElementById("hn-tags-"         + id);
  var sizeSel    = section.querySelector("[data-size-select]");
  var skipBtn    = document.getElementById("hn-skip-"         + id);
  var fnameIn    = document.getElementById("hn-fname-"        + id);
  var lnameIn    = document.getElementById("hn-lname-"        + id);
  var notifyForm = document.getElementById("hn-notify-"       + id);
  var notifyEmailEl = document.getElementById("hn-notify-email-" + id);
  var notifyBodyEl  = document.getElementById("hn-notify-body-"  + id);

  var capturedEmail = "";

  function show(el) { el && el.classList.remove("hn-split__step--hidden"); }
  function hide(el) { el && el.classList.add("hn-split__step--hidden"); }
  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function sendNotification(fname, lname, cemail, size) {
    if (!notifyForm || (!fname && !lname)) return;
    var name = (fname + " " + lname).trim();
    if (notifyEmailEl) notifyEmailEl.value = cemail || "unknown";
    if (notifyBodyEl) {
      notifyBodyEl.value =
        "ACTION REQUIRED — Add name to customer profile manually:\n\n" +
        "Name: " + name + "\n" +
        "Email: " + cemail + "\n" +
        "T-shirt size: " + (size || "not provided") + "\n\n" +
        "Go to: Shopify Admin > Customers > search for this email > edit name.";
    }
    fetch(notifyForm.action, { method: "POST", body: new FormData(notifyForm) });
  }

  function showSuccess() {
    var fname  = sessionStorage.getItem(fnameKey)  || "";
    var lname  = sessionStorage.getItem(lnameKey)  || "";
    var size   = sessionStorage.getItem(sizeKey)   || "";
    var cemail = sessionStorage.getItem(cemailKey) || "";
    sessionStorage.removeItem(fnameKey);
    sessionStorage.removeItem(lnameKey);
    sessionStorage.removeItem(sizeKey);
    sessionStorage.removeItem(cemailKey);

    sendNotification(fname, lname, cemail, size);

    hide(step1);
    hide(step2);
    section.classList.remove("hn-split--step2");
    section.classList.add("hn-split--success");
    show(successEl);
    document.documentElement.removeAttribute("data-hn-loading");
    section.style.visibility = "";

    var r = sessionStorage.getItem(redirectKey) || "";
    sessionStorage.removeItem(redirectKey);
    if (r) setTimeout(function () { window.location.href = r; }, 1400);
  }

  if (sessionStorage.getItem(doneKey)) {
    sessionStorage.removeItem(doneKey);
    showSuccess();
    return;
  }

  document.documentElement.removeAttribute("data-hn-loading");
  section.style.visibility = "";

  if (step1Btn) {
    step1Btn.addEventListener("click", function () {
      var email = emailIn ? emailIn.value.trim() : "";
      if (!isValidEmail(email)) {
        if (emailErr) emailErr.style.display = "block";
        if (emailIn) emailIn.focus();
        return;
      }
      if (emailErr) emailErr.style.display = "none";
      capturedEmail = email;
      if (emailHid) emailHid.value = email;
      hide(step1);
      section.classList.add("hn-split--step2");
      show(step2);
      var ff = step2 && step2.querySelector("input:not([type=hidden])");
      if (ff) setTimeout(function () { ff.focus(); }, 50);
    });
  }

  if (emailIn) {
    emailIn.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); if (step1Btn) step1Btn.click(); }
    });
  }

  if (sizeSel && tagsIn) {
    sizeSel.addEventListener("change", function () {
      tagsIn.value = sizeSel.value ? "newsletter," + sizeSel.value : "newsletter";
    });
  }

  if (form2) {
    form2.addEventListener("submit", function () {
      if (emailHid && capturedEmail) emailHid.value = capturedEmail;
      sessionStorage.setItem(fnameKey,  fnameIn  ? fnameIn.value.trim()  : "");
      sessionStorage.setItem(lnameKey,  lnameIn  ? lnameIn.value.trim()  : "");
      sessionStorage.setItem(sizeKey,   sizeSel  ? sizeSel.value         : "");
      sessionStorage.setItem(cemailKey, capturedEmail);
      sessionStorage.setItem(doneKey, "1");
      var r = (section.getAttribute("data-redirect") || "").trim();
      if (r && r !== window.location.pathname) sessionStorage.setItem(redirectKey, r);
      hide(step2);
      section.classList.remove("hn-split--step2");
      section.classList.add("hn-split--success");
      show(successEl);
    });
  }

  if (skipBtn) {
    skipBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (capturedEmail && form2 && emailHid) {
        emailHid.value = capturedEmail;
        fetch(form2.action, { method: "POST", body: new FormData(form2) });
      }
      hide(step2);
      section.classList.remove("hn-split--step2");
      section.classList.add("hn-split--success");
      show(successEl);
      var r = (section.getAttribute("data-redirect") || "").trim();
      if (r && r !== window.location.pathname) {
        setTimeout(function () { window.location.href = r; }, 1400);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.getElementById("lp2-{{ section.id }}");
  if (!wrap) return;
  var id = "{{ section.id }}";
  var doneKey = "lp2_done_lp2_" + id;

  var step1   = document.getElementById("lp2-step1-"   + id);
  var success = document.getElementById("lp2-success-" + id);

  function showSuccess() {
    if (step1)   step1.classList.add("lp2__hidden");
    if (success) success.classList.remove("lp2__hidden");
    document.documentElement.removeAttribute("data-lp2-loading");
    wrap.style.visibility = "";
  }

  if (sessionStorage.getItem(doneKey)) {
    sessionStorage.removeItem(doneKey);
    showSuccess();
    return;
  }

  document.documentElement.removeAttribute("data-lp2-loading");
  wrap.style.visibility = "";

  var form = document.getElementById("lp2-form-" + id);
  if (form) {
    form.addEventListener("submit", function () {
      sessionStorage.setItem(doneKey, "1");
      showSuccess();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-pageCN"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.getElementById("lp4-{{ section.id }}");
  if (!wrap) return;
  var id = "{{ section.id }}";
  var doneKey = "lp4_done_lp4_" + id;

  var step1   = document.getElementById("lp4-step1-"   + id);
  var success = document.getElementById("lp4-success-" + id);

  function showSuccess() {
    if (step1)   step1.classList.add("lp4__hidden");
    if (success) success.classList.remove("lp4__hidden");
    document.documentElement.removeAttribute("data-lp4-loading");
    wrap.style.visibility = "";
  }

  if (sessionStorage.getItem(doneKey)) {
    sessionStorage.removeItem(doneKey);
    showSuccess();
    return;
  }

  document.documentElement.removeAttribute("data-lp4-loading");
  wrap.style.visibility = "";

  var form = document.getElementById("lp4-form-" + id);
  if (form) {
    form.addEventListener("submit", function () {
      sessionStorage.setItem(doneKey, "1");
      showSuccess();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-pageJP"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.getElementById("lp3-{{ section.id }}");
  if (!wrap) return;
  var id = "{{ section.id }}";
  var doneKey = "lp3_done_lp3_" + id;

  var step1   = document.getElementById("lp3-step1-"   + id);
  var success = document.getElementById("lp3-success-" + id);

  function showSuccess() {
    if (step1)   step1.classList.add("lp3__hidden");
    if (success) success.classList.remove("lp3__hidden");
    document.documentElement.removeAttribute("data-lp3-loading");
    wrap.style.visibility = "";
  }

  if (sessionStorage.getItem(doneKey)) {
    sessionStorage.removeItem(doneKey);
    showSuccess();
    return;
  }

  document.documentElement.removeAttribute("data-lp3-loading");
  wrap.style.visibility = "";

  var form = document.getElementById("lp3-form-" + id);
  if (form) {
    form.addEventListener("submit", function () {
      sessionStorage.setItem(doneKey, "1");
      showSuccess();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
